<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import Tile, { TileProps } from '../components/Tile.svelte';
    import { idPageRealisations, idPagePressRevue, idPagePlenaries, idPagePress } from '../scripts/router2';
    import { redirectTo } from '../scripts/router1';
    import { getDeliverables } from '../scripts/apiDeliverables';
    import { storeDeliverables, storeDeliverablesError } from "../scripts/deliverable";
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr } from "../scripts/store";

    const tilePlenary_fr: TileProps = {
        icon: "../assets/images/worksites/worksite3.png", 
        title: "Plénières", 
        text: "Nos supports de sessions plénières"
    }

    const tilePlenary_en: TileProps = {
        icon: "../assets/images/worksites/worksite3.png", 
        title: "Plenary", 
        text: "Our plenary session ressources"
    }

    const tilePressRevue_fr: TileProps = {
        icon: "../assets/images/worksites/worksite1.png", 
        title: "Revues de presse", 
        text: "Notre API News mensuelle"
    }

    const tilePressRevue_en: TileProps = {
        icon: "../assets/images/worksites/worksite1.png", 
        title: "Our press reviews", 
        text: "Our monthly API News"
    }

    const tileRealisation_fr: TileProps = {
        icon: "../assets/images/worksites/worksite2.png", 
        title: "Réalisations", 
        text: "Nos livrables réalisés en chantiers"
    }

    const tileRealisation_en: TileProps = {
        icon: "../assets/images/worksites/worksite2.png", 
        title: "Our achievements", 
        text: "Our deliverables made in workshops"
    }

    const tilePress_fr: TileProps = {
        icon: "../assets/images/worksites/worksite3.png", 
        title: "Presse", 
        text: "Nos communiqués et nos dossiers de presse"
    }

    const tilePress_en: TileProps = {
        icon: "../assets/images/worksites/worksite3.png", 
        title: "Press", 
        text: "Our press releases and press kits"
    }

    onMount(async () => {
        getDeliverablesIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getRealisationsIfEmpty
     */
     function getDeliverablesIfEmpty() {
        if ($storeDeliverables.length <= 0) {
            const returnValue = getDeliverables();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeDeliverablesError);
                };
            });
        }
    }
</script>
    
<style lang="scss">

    .noslivrables {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__tile {
            margin: 0 0 60px 0;
        }
    }

    @include large {
        .noslivrables {
            &__tiles {
                display: grid;
                grid-template-columns: 25% 25% 25% 25%;
                gap: 10px;
                align-items: flex-start;
                flex-direction: row;
                flex-wrap: nowrap;
                margin: 0 0 60px 0;
            }
            &__tile {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                width: 100%;
                height: 100%;
            }
        }
    }

</style>

<div class="noslivrables">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="nos livrables"/>
    {:else}
    <PageHeader props="our deliverables"/>
    {/if}
    <div class="bloc noslivrables__bloc">
        <div class="noslivrables__title font__h3">
            {#if ($storeLanguage == $lang_fr)}
            Retrouvez ci-dessous l’ensemble des livrables du collectif
            {:else}
            Find below all the deliverables of the collective
            {/if}
        </div>
        <div class="noslivrables__tiles">
            <div class="noslivrables__tile" on:click={() => redirectTo(idPagePlenaries)} on:keydown={() => redirectTo(idPagePlenaries)}>
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={tilePlenary_fr}/>
                {:else}
                <Tile props={tilePlenary_en}/>
                {/if}
            </div>
            <div class="noslivrables__tile" on:click={() => redirectTo(idPagePressRevue)} on:keydown={() => redirectTo(idPagePressRevue)}>
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={tilePressRevue_fr}/>
                {:else}
                <Tile props={tilePressRevue_en}/>
                {/if}
            </div>
            <div class="noslivrables__tile" on:click={() => redirectTo(idPageRealisations)} on:keydown={() => redirectTo(idPageRealisations)}>
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={tileRealisation_fr}/>
                {:else}
                <Tile props={tileRealisation_en}/>
                {/if}
            </div>
            <div class="noslivrables__tile" on:click={() => redirectTo(idPagePress)} on:keydown={() => redirectTo(idPagePress)}>
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={tilePress_fr}/>
                {:else}
                <Tile props={tilePress_en}/>
                {/if}
            </div>
        </div>    
    </div>
</div>
